export default __webpack_public_path__ + "static/media/ZenOldMincho-Black.a4edea91.ttf";